<div class="brand-container" *transloco="let t">
  <img class="merchant-logo"
       ngSrc="{{headerLogo()}}" alt="brand-logo"
       height="32" width="32">
  <div class="brand-title">{{ campaignDetails().title ?? campaignDetails().organization.name }}</div>
  <div class="promo-coins-container" (click)="onValueRatingOpened($event)">
    @if(campaignDetails().type == CampaignType.FREE_MONEY && valueChipIndex()) {
      @switch (valueChipIndex()) {
        @case (1) {
          <img [ngSrc]="'assets/images/coins/value-rating-1.svg'"
               alt="coins"
               [height]="26"
               [width]="26">
        }
        @case (2) {
          <img [ngSrc]="'assets/images/coins/value-rating-2.svg'"
               alt="coins"
               [height]="26"
               [width]="34">
        }
        @case (3) {
          <img [ngSrc]="'assets/images/coins/value-rating-3.svg'"
               alt="coins"
               [height]="26"
               [width]="42">
        }
        @case (4) {
          <img [ngSrc]="'assets/images/coins/value-rating-4.svg'"
               alt="coins"
               [height]="26"
               [width]="50">
        }
        @case (5) {
          <img [ngSrc]="'assets/images/coins/value-rating-5.svg'"
               alt="coins"
               [height]="26"
               [width]="58">
        }
      }
    } @else if(campaignDetails().type == CampaignType.LOYALTY) {
      <div class="loyalty">
        <lib-loyalty-radial-bar [loyaltyScore]="campaignDetails().userLoyalty?.loyaltyScore ?? 1"
                                [loyaltyLevel]="campaignDetails().userLoyalty?.level  ?? LoyaltyLevel.CASUAL"
                                [size]="Size.BIG"></lib-loyalty-radial-bar>
        <div>{{ t('loyaltyLevels.' + (campaignDetails().userLoyalty?.level ?? LoyaltyLevel.CASUAL)) + ' ' + (campaignDetails().userLoyalty?.loyaltyScore ?? 1) }}</div>
      </div>
    }
  </div>
</div>
